import createGetFormNames from './selectors/getFormNames';
import plain from './structure/plain';

export default createGetFormNames(plain);


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/redux-form/es/getFormNames.js
// module id = 1217
// module chunks = 4